<template>
    <router-link class="table__body__row__anchor" :to="`/clients/${ row.id }`">
        <span v-for="( key, index ) in headers"
            class="table__body__row__text position--relative display--flex"
            :class="`table__${model}__col__${index}`"
            :key="index"
        >
            <template v-if="[ 'type' ].includes( key.name )">
                {{ $t(`associateTypes.${associateTypes[row[key.name].id]}`) || '---'}}
            </template>
            <template v-else-if="[ 'number' ].includes( key.name )">
                {{ row.number }}
            </template>
            <template v-else-if="[ 'fullName' ].includes( key.name )">
                {{ row.name }}
            </template>
            <template v-else >
                {{ row[key.name] || '---' }}
            </template>
        </span>
    </router-link>
</template>
<script>
// hooks
import tableStructure from '@/hooks/use-table';

// consts
import { associateTypes } from '@/configs/const';

export default {
    ...tableStructure,
    setup () {
        return { associateTypes };
    }
};
</script>